import { EnumUsuarioEventoAcesso } from '../enums/usuario-evento-acesso.enum';

/** Representa os dados de um evento de acesso do usuário */
export interface IUsuarioEventoAcesso {
  id: number;
  name: string;
  description: string;
  backgroundColor: string
  color: string;
}

/** Dados dos eventos de acesso do usuário */
export const UsuarioEventoAcessoData: Record<EnumUsuarioEventoAcesso, IUsuarioEventoAcesso> = {
  [EnumUsuarioEventoAcesso.LOGIN]: {
    id: EnumUsuarioEventoAcesso.LOGIN,
    name: 'Login',
    description: 'Usuário realizou login no sistema',
    backgroundColor: '#B2F1CB',
    color: '#20B75D'
  },
  [EnumUsuarioEventoAcesso.LOGOUT]: {
    id: EnumUsuarioEventoAcesso.LOGOUT,
    name: 'Logout',
    description: 'Usuário realizou logout do sistema',
    backgroundColor: '#FFEDCC',
    color: '#FFA500'

  },
  [EnumUsuarioEventoAcesso.LOGIN_FALHA]: {
    id: EnumUsuarioEventoAcesso.LOGIN_FALHA,
    name: 'Falha no Login',
    description: 'Tentativa de login falhou',
    backgroundColor: '#FCD3D1',
    color: '#F55E59'
  },
  [EnumUsuarioEventoAcesso.ALTERACAO_SENHA]: {
    id: EnumUsuarioEventoAcesso.ALTERACAO_SENHA,
    name: 'Alteração de Senha',
    description: 'Usuário alterou sua senha',
    backgroundColor: '#D0E3F7',
    color: '#237DD8'
  }
};

/** Lista dos eventos de acesso do usuário */
export const usuarioEventoAcessoList: IUsuarioEventoAcesso[] = Object.values(UsuarioEventoAcessoData);
